import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AirdropFarmingIntroStore {
  hasSeenIntro: boolean;
  setHasSeenIntro: (seen: boolean) => void;
}

export const useAirdropFarmingIntroStore = create<AirdropFarmingIntroStore>()(
  persist(
    (set) => ({
      hasSeenIntro: false,
      setHasSeenIntro: (seen) => set({ hasSeenIntro: seen }),
    }),
    {
      name: "airdrop-farming-intro",
      partialize: (state) => ({
        hasSeenIntro: state.hasSeenIntro,
      }),
    },
  ),
);
